import { createAction } from "@reduxjs/toolkit";
import { Notification } from "./types";

export const addNotification = createAction<Notification>('notifications/addNotification');
